import React, { useCallback, useEffect, useRef } from 'react'
import styles from './style.module.css';
import Typography from '../../../design-system/lib/Typography';
import IconProvider from '../../../design-system/lib/IconProvider';
import { BOX, Ic_danger } from '../../../assets';
import Button from '../../../design-system/lib/Button';
import { getTableOrderList } from '../table-list/action/getTableOrderList';
import history from '../../../service/history';
import { PHubDES } from "@onro/onboarding";
import { useTranslation } from 'react-i18next';
import { ServicesVehicletypeAction } from '../../../Redux/actions/actions';
import { useDispatch, useSelector } from 'react-redux';







function TableNoOrder() {
      const { t, i18n } = useTranslation();
          const dispatch = useDispatch();
          const center = useSelector((state) => state.Map.center)

  return (
    <div className='jojojoj'
      style={{ display: 'flex', position: 'relative', height: `calc(100vh - 104px)`, width: "100%", flexDirection: 'column', transition: "all .3s ease-in-out" ,justifyContent:"center",alignItems:"center"}}>
          <div className={styles.dialog} style={{width:"400px"}}>
            {/* <IconProvider Icon={BOX} style={{marginBottom:"16px"}} />
            <Typography weight='Body_Middle_Bold' text='Create your first order' style={{textAlign:"center" , marginBottom:"4px"}} />
            <Typography weight='Body_Tiny_Regular' text='Your orders will be shown here in table with full details and actions' style={{textAlign:"center",marginBottom:"16px"}} />
            <Button size='Medium' type='Primary' text='Create Order' onClick={()=>{history.push("/neworder")}}/>
          */}

                  <PHubDES articleTitle="How to create order?" articleLink="https://help.onro.io/en/articles/9980258-create-your-first-order" emptyStateTitle={t("Create P_HUB_D Only order")} emptyStateDescription={t("Your orders will be shown here in table with full details and actions" )}
                  ImportButtonTitle={t("Import")}  NewButtonTitle={t("new")}  onImportAction={()=>{history.push("/BulkImport")}} onNewAction={()=>{
                    dispatch(ServicesVehicletypeAction(dispatch, center))
                    // dispatch(ChangeNewTravelDialoge());
                    history.push("/neworder")
                  }} />
          
         
          </div>
    </div>
  )
}
export default TableNoOrder